import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  locationBasedStockReturnsPerMonth: [],
  addData: {},
  sorted: [],
  StockReturnTypes: [],
};

const slice = createSlice({
  name: 'StockReturns',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET StockReturnManagement
    getAllStockReturnTypesSuccess(state, action) {
      state.StockReturnTypes = action.payload.data;
    },
    // GET StockReturnManagement
    getStockReturnsSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET StockReturnManagement
    locationBasedStockReturnsPerMonthSuccess(state, action) {
      state.locationBasedStockReturnsPerMonth = action.payload.data;
    },

    addOrUpdateStockReturns(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllStockReturns() {
  return async () => {
    try {
      const response = await get(`getAllStockReturns`);
      if (response.status) {
        dispatch(slice.actions.getStockReturnsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getLocationBasedStockReturnsPerMonth(year, month) {
  return async () => {
    try {
      const response = await get(`locationBasedStockReturnsPerMonth?year=${year}&month=${month}`);
      if (response.status) {
        dispatch(slice.actions.locationBasedStockReturnsPerMonthSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addStockReturn(body) {
  return async () => {
    try {
      const response = await post(`StockReturn`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockReturns(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateStockReturnStatus(body) {
  return async () => {
    try {
      const response = await put(`StockReturnStatus`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockReturns(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteStockReturn(body) {
  return async () => {
    try {
      const response = await deleteMethod(`StockReturn`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateStockReturns(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
